import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { RouteGuard } from "./utilities";

// sacco page imports
const Onboarding = React.lazy(() => import("../pages/Sacco/Onboarding"));
const SaccoRegistration = React.lazy(() =>
  import("../pages/Sacco/SaccoUserRegistration"),
);
const UserManager = React.lazy(() => import("../pages/Sacco/UserManager"));
const WalletTransactions = React.lazy(() =>
  import("../pages/Sacco/WalletTransactions"),
);
const StageCollections = React.lazy(() =>
  import("../pages/Sacco/StageCollections"),
);
const SaccoProfile = React.lazy(() =>
  import("../pages/Sacco/SaccoProfile"),
);

const SaccoFinancesPlaceholder = () => (
  <div className="container-fluid p-4">
    <h4 className="header-title">Finances</h4>
    <p className="text-muted mb-0">This section is not available yet.</p>
  </div>
);

const guarded = (auth: boolean | undefined, element: React.ReactNode) => (
  <React.Suspense fallback={<>..</>}>
    <RouteGuard auth={auth}>{element}</RouteGuard>
  </React.Suspense>
);

const SaccoRoutes = ({ auth }) => {
  return (
    <Routes>
      {/* Public: sacco member self-registration after Firebase sign-up */}
      <Route
        path="account/register"
        element={
          <React.Suspense fallback={<>..</>}>
            <SaccoRegistration />
          </React.Suspense>
        }
      />

      {/* Admin: create sacco (nav menu → /sacco/registration) */}
      <Route
        path="registration"
        element={guarded(auth, <Onboarding />)}
      />
      <Route
        path="register"
        element={<Navigate to="/sacco/registration" replace />}
      />

      <Route path="team" element={guarded(auth, <UserManager />)} />
      <Route
        path="finances"
        element={guarded(auth, <SaccoFinancesPlaceholder />)}
      />
      <Route
        path="wallet-transactions"
        element={guarded(auth, <WalletTransactions />)}
      />
      <Route
        path="stage-collections"
        element={guarded(auth, <StageCollections />)}
      />
      <Route
        path="profile"
        element={guarded(auth, <SaccoProfile />)}
      />
    </Routes>
  );
};

export default SaccoRoutes;
